module.exports = __webpack_public_path__ + "img/lanmu-04.c8638772.jpg";